import axios from "@/crm-axios";

const BASE_URL = "/crm/v2/migration/afterdoc";

// crm-api 는 X-Acting-Company-Id 헤더로 대상 병원을 판별한다 (모든 요청 필수)
const actingConfig = (companyId) => ({
  headers: { "X-Acting-Company-Id": companyId },
});

export const crmMigrationApi = {
  // 드라이런 (등록하지 않고 검증 결과만 반환)
  preview(companyId, payload) {
    return axios.post(`${BASE_URL}/preview`, payload, actingConfig(companyId));
  },

  // 실제 등록 실행 (카카오 템플릿 등록 포함)
  apply(companyId, payload) {
    return axios.post(`${BASE_URL}/apply`, payload, actingConfig(companyId));
  },

  // 카카오 템플릿 검수 상태 조회.
  // channelId 는 등록에 쓴 채널과 같아야 한다. 안 넘기면 서버가 대표 채널을 읽어
  // "등록은 A 채널, 검수 상태는 B 채널" 로 어긋난다.
  getInspectionStatus(companyId, channelId) {
    return axios.get(`${BASE_URL}/inspection-status`, {
      ...actingConfig(companyId),
      params: channelId ? { channelId } : undefined,
    });
  },
};

// 드라이런 판정 매핑
export const VERDICT_TEXT_MAP = {
  ok: "정상",
  warn: "경고",
  skip: "스킵",
  error: "오류",
};

export const VERDICT_COLOR_MAP = {
  ok: "green",
  warn: "orange",
  skip: "default",
  error: "red",
};

// 등록 실행 결과 매핑
export const RESULT_TEXT_MAP = {
  created: "등록됨",
  skipped: "스킵",
  failed: "실패",
};

export const RESULT_COLOR_MAP = {
  created: "green",
  skipped: "default",
  failed: "red",
};

// 카카오 템플릿 검수 상태 매핑
export const INSPECTION_STATUS_TEXT_MAP = {
  N: "미검수",
  I: "검수중",
  O: "승인",
  R: "반려",
};

export const INSPECTION_STATUS_COLOR_MAP = {
  N: "default",
  I: "blue",
  O: "green",
  R: "red",
};

// 대상 종류 매핑
export const ITEM_KIND_TEXT_MAP = {
  channel: "채널",
  tag: "태그",
  template: "템플릿",
  scenario: "시나리오",
};
